import React from 'react';

const Logo = () => {
    return (
        <a  className="qodef-header-logo-link qodef-height--set qodef-source--image" href="/" rel="home">
            <img 
                loading="lazy" 
                width="296" 
                height="68" 
                src="/img/pmclogo.png" 
                className="qodef-header-logo-image qodef--main" 
                alt="logo main" 
             
            />
        </a>
    );
};

export default Logo;